const parkinsonTypes = [
  { value: 1762, label: "PARKINSON" },
  { value: 1763, label: "SYNDROMES PARKINSONIENS" },
  { value: 1764, label: "SOINS PALLIATIFS" },
];

export default parkinsonTypes;
